import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";
import "./style.css";
import { useThemePreference } from "./composables/useThemePreference";

async function bootstrap() {
  const app = createApp(App);

  app.use(createPinia());
  app.use(router);

  const { getCurrentMode } = useThemePreference();
  getCurrentMode();

  if ("serviceWorker" in navigator && import.meta.env.PROD) {
    void navigator.serviceWorker.register("/sw.js");
  }

  app.mount("#app");
}

void bootstrap();
